import React from 'react'
import QRcode from "qrcode.react";
import { Modal } from '../Modal';
import '../../assets/scss/qrcode-modal.scss';
import { useTranslation } from 'react-i18next';


type Props = {
  isOpen: boolean;
  onClose: () => void;
  chatId?: string;
};

export function QrCodeModal({ isOpen, onClose, chatId }: Props) {
  const { t } = useTranslation();
  const url = new URL(window.location.href);
  url.searchParams.set('upload', '1');
  if (chatId && chatId !== 'group') {
    url.searchParams.set('chatId', chatId);
  } else {
    url.searchParams.delete('chatId');
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('qrModal:title')}>
      <div className="qr-code-modal__content">
        <QRcode value={url.toString()} size={270} />
      </div>
    </Modal>
  );
}
